import { render, staticRenderFns } from "./MagicTips.vue?vue&type=template&id=096dc074&scoped=true"
import script from "./MagicTips.vue?vue&type=script&lang=js"
export * from "./MagicTips.vue?vue&type=script&lang=js"
import style0 from "./MagicTips.vue?vue&type=style&index=0&id=096dc074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096dc074",
  null
  
)

export default component.exports